/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({
  description,
  lang,
  meta,
  title,
  ogImage = "https://ik.imagekit.io/ikmedia/Graphics/2024%20Website%20Graphics/OG%20Images/OG%20Homepage%20blank.jpg?updatedAt=1714687781461&tr=w-1200:l-text,i-Manage,%20collaborate,%20and%20deliver%20perfect%20media%20assets%20at%20scale,co-FFFFFF,fs-40,lx-95,ly-250,w-450,tg-b,ia-left,ff-fonts@@Poppins-Regular.ttf,l-end,f-png,e-sharpen",
  appendSiteName = true
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  // add | ImageKit.io in title if not alraedy present
  if (!title.toLowerCase().includes("imagekit") && appendSiteName) {
    title = title + " | ImageKit.io"
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title ?? site.siteMetadata.title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: "image",
          property: `og:image`,
          content: ogImage,
        },
        {
          name: "image",
          property: "og:image:secure_url",
          content: ogImage,
        }
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
